import { registerCustomStage } from "../../content/customRegistry.js";
import { startStageCommand } from "../../domain/startStage.js";
import type { Command } from "../../domain/types/index.js";
import { toPlayable } from "../stageMaker/toPlayable.js";
import type { StoredStage } from "../stageMaker/stageRecord.js";

export function beginCustomPlay(record: StoredStage): Command {
  const playable = toPlayable(record);
  registerCustomStage(playable.stage, playable.cases, record);
  return startStageCommand(record.id);
}
